 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1DAMINGXINJUN from '@/components/0_chapter1damingxinjun'
 import A_CHAPTER2MONARCHSYSTEM from '@/components/1_chapter2monarchsystem'
 import A_CHAPTER3FIRSTCLASSPEAK from '@/components/2_chapter3firstclasspeak'
 import A_CHAPTER4ASSASSINATION from '@/components/3_chapter4assassination'
 import A_CHAPTER5PREPARETOESTABLISHAUTHORITY from '@/components/4_chapter5preparetoestablishauthority'
 import A_CHAPTER6SIBLINGFLOWER from '@/components/5_chapter6siblingflower'
 import A_CHAPTER7FALLENHEARTFLAME from '@/components/6_chapter7fallenheartflame'
 import A_CHAPTER8XUERENGUI from '@/components/7_chapter8xuerengui'
 import A_CHAPTER9YUWENCHENGDU from '@/components/8_chapter9yuwenchengdu'
 import A_CHAPTER10ONEDRAGONANDTWOPHOENIXES from '@/components/9_chapter10onedragonandtwophoenixes'
 import A0_CHAPTER11THEFIRSTKNIFEOFTHENEWEMPEROR from '@/components/10_chapter11thefirstknifeofthenewemperor'
 import A1_CHAPTER12INTERNALINCISION from '@/components/11_chapter12internalincision'
 import A2_CHAPTER13ELIMINATEYANFAMILY from '@/components/12_chapter13eliminateyanfamily'
 import A3_CHAPTER14PROCESSINGANDAPPOINTMENT from '@/components/13_chapter14processingandappointment'
 import A4_CHAPTER15CONTENTIONFORPOWER from '@/components/14_chapter15contentionforpower'
 import A5_CHAPTER16CONTRALATERALPERFORATINGINTESTINE from '@/components/15_chapter16contralateralperforatingintestine'
 import A6_CHAPTER17SWORDDANCE from '@/components/16_chapter17sworddance'
 import A7_CHAPTER18BLOODSTAINEDTHRONEROOM from '@/components/17_chapter18bloodstainedthroneroom'
 import A8_CHAPTER19XUANYUANSWORD from '@/components/18_chapter19xuanyuansword'
 import A9_CHAPTER20LONGLIVEHISMAJESTY from '@/components/19_chapter20longlivehismajesty'
 import A0_CHAPTER21AWAY from '@/components/20_chapter21away'
 import A1_CHAPTER22YANRUYU from '@/components/21_chapter22yanruyu'
 import A2_CHAPTER23COLLATEITEMS from '@/components/22_chapter23collateitems'
 import A3_CHAPTER24LOTTERYDRAW from '@/components/23_chapter24lotterydraw'
 import A4_CHAPTER25FLOWERINGOFBEGONIA from '@/components/24_chapter25floweringofbegonia'
 import A5_CHAPTER26HYPOHEAVYDRUG from '@/components/25_chapter26hypoheavydrug'
 import A6_CHAPTER27GUSANTONG from '@/components/26_chapter27gusantong'
 import A7_CHAPTER28PASTEVENTS from '@/components/27_chapter28pastevents'
 import A8_CHAPTER29CULTIVATION from '@/components/28_chapter29cultivation'
 import A9_CHAPTER30XINJUNSSECONDKNIFE from '@/components/29_chapter30xinjunssecondknife'
 import A0_CHAPTER31HANDTOHAND from '@/components/30_chapter31handtohand'
 import A1_CHAPTER32ANNIHILATION from '@/components/31_chapter32annihilation'
 import A2_CHAPTER33EXTERMINATION from '@/components/32_chapter33extermination'
 import A3_CHAPTER34FORTUITOUSBEARSEA from '@/components/33_chapter34fortuitousbearsea'
 import A4_CHAPTER35ANCIENTEVIL from '@/components/34_chapter35ancientevil'
 import A5_CHAPTER36XUNDOBERMAN from '@/components/35_chapter36xundoberman'
 import A6_CHAPTER37LIHOUANDZHANGLIANG from '@/components/36_chapter37lihouandzhangliang'
 import A7_CHAPTER38REACTION from '@/components/37_chapter38reaction'
 import A8_CHAPTER39CLOUDEMISSARY from '@/components/38_chapter39cloudemissary'
 import A9_CHAPTER40PUNCTURINGSHOWOFF from '@/components/39_chapter40puncturingshowoff'
 import A0_CHAPTER41BEHEADING from '@/components/40_chapter41beheading'
 import A1_CHAPTER42COUNTERMEASURES from '@/components/41_chapter42countermeasures'
 import A2_CHAPTER43PANCAKESINTHEIMPERIALSTUDY from '@/components/42_chapter43pancakesintheimperialstudy'
 import A3_CHAPTER44ZHUGEZHENG from '@/components/43_chapter44zhugezheng'
 import A4_CHAPTER45PARTIESREACTIONS from '@/components/44_chapter45partiesreactions'
 import A5_CHAPTER46YUELINARMY from '@/components/45_chapter46yuelinarmy'
 import A6_CHAPTER47INNERBLOODFLOW1 from '@/components/46_chapter47innerbloodflow1'
 import A7_CHAPTER48INNERBLOODFLOW2 from '@/components/47_chapter48innerbloodflow2'
 import A8_CHAPTER49CLEARTHOROUGHLY from '@/components/48_chapter49clearthoroughly'
 import A9_CHAPTER50POPULARPRAISE from '@/components/49_chapter50popularpraise'
 import A0_CHAPTER51EXITINGTHECAPITALCITY from '@/components/50_chapter51exitingthecapitalcity'
 import A1_CHAPTER52COMETOTHEDOOR from '@/components/51_chapter52cometothedoor'
 import A2_CHAPTER53UPPERCLOUD from '@/components/52_chapter53uppercloud'
 import A3_CHAPTER54SALIDIN from '@/components/53_chapter54salidin'
 import A4_CHAPTER55BEHEADING from '@/components/54_chapter55beheading'
 import A5_CHAPTER56ASCENDING from '@/components/55_chapter56ascending'
 import A6_CHAPTER57DOMINEERING from '@/components/56_chapter57domineering'
 import A7_CHAPTER58MALEORFEMALE from '@/components/57_chapter58maleorfemale'
 import A8_CHAPTER59WARFARE from '@/components/58_chapter59warfare'
 import A9_CHAPTER60COMPROMISE from '@/components/59_chapter60compromise'
 import A0_CHAPTER61SUNMOONGODCULTACCESSION from '@/components/60_chapter61sunmoongodcultaccession'
 import A1_CHAPTER62SURPRISE from '@/components/61_chapter62surprise'
 import A2_CHAPTER63ZHOUYU from '@/components/62_chapter63zhouyu'
 import A3_CHAPTER64WUSONGSHEN from '@/components/63_chapter64wusongshen'
 import A4_CHAPTER65NIGHTATTACKONWATERSTRONGHOLD from '@/components/64_chapter65nightattackonwaterstronghold'
 import A5_CHAPTER66THUNDERATTACK from '@/components/65_chapter66thunderattack'
 import A6_CHAPTER67FIRSTNAVALBATTLE from '@/components/66_chapter67firstnavalbattle'
 import A7_CHAPTER68TESTZHOUYU from '@/components/67_chapter68testzhouyu'
 import A8_CHAPTER69STRAIGHTATTACKTOWUSOU from '@/components/68_chapter69straightattacktowusou'
 import A9_CHAPTER70GENERALQIJIGUANG from '@/components/69_chapter70generalqijiguang'
 import A0_CHAPTER71DECEIVINGOTHERSBYTHEIRSIDE from '@/components/70_chapter71deceivingothersbytheirside'
 import A1_CHAPTER72THECALCULATIONOFQINHUI from '@/components/71_chapter72thecalculationofqinhui'
 import A2_CHAPTER73STRAIGHTBLOCKADE from '@/components/72_chapter73straightblockade'
 import A3_CHAPTER74AQUARELLI from '@/components/73_chapter74aquarelli'
 import A4_CHAPTER75STRUGGLINGTHEDEVILISLAND from '@/components/74_chapter75strugglingthedevilisland'
 import A5_CHAPTER76KILLTHEDEVILISLAND from '@/components/75_chapter76killthedevilisland'
 import A6_CHAPTER77TAKEDOWNAVILLAGE from '@/components/76_chapter77takedownavillage'
 import A7_CHAPTER78CAPTIVEGIRL from '@/components/77_chapter78captivegirl'
 import A8_CHAPTER79EXTORTIONOFCONFESSIONSBYSEVEREPUNISHMENT from '@/components/78_chapter79extortionofconfessionsbyseverepunishment'
 import A9_CHAPTER80RECTIFICATIONOFTHESEAMAN from '@/components/79_chapter80rectificationoftheseaman'
 import A0_CHAPTER81EXPEDITIONOFTHEUSURPER from '@/components/80_chapter81expeditionoftheusurper'
 import A1_CHAPTER82ENCOUNTERINGPIRATES from '@/components/81_chapter82encounteringpirates'
 import A2_CHAPTER83ZHENGSHI from '@/components/82_chapter83zhengshi'
 import A3_CHAPTER84FOURSYMBOLSFORMATION from '@/components/83_chapter84foursymbolsformation'
 import A4_CHAPTER85KAIJU from '@/components/84_chapter85kaiju'
 import A5_CHAPTER86ZHENGSHISHI from '@/components/85_chapter86zhengshishi'
 import A6_CHAPTER87BOILTEAONDECK from '@/components/86_chapter87boilteaondeck'
 import A7_CHAPTER88THENINJA from '@/components/87_chapter88theninja'
 import A8_CHAPTER89ENDOPARASITE from '@/components/88_chapter89endoparasite'
 import A9_CHAPTER90ASSASSINATION from '@/components/89_chapter90assassination'
 import A0_CHAPTER91THROWYOURSELFINTOTHEARMS from '@/components/90_chapter91throwyourselfintothearms'
 import A1_CHAPTER92OLDRESENTMENT from '@/components/91_chapter92oldresentment'
 import A2_CHAPTER93TRAVELWITHTHEUNITEDSTATES from '@/components/92_chapter93travelwiththeunitedstates'
 import A3_CHAPTER94THECITYGATESWERECLOSED from '@/components/93_chapter94thecitygateswereclosed'
 import A4_CHAPTER95MIDNIGHTAMBUSH from '@/components/94_chapter95midnightambush'
 import A5_CHAPTER96FLYINGSTONELIKELIGHTNING from '@/components/95_chapter96flyingstonelikelightning'
 import A6_CHAPTER97THEYREHUNTING from '@/components/96_chapter97theyrehunting'
 import A7_CHAPTER98CITYINN from '@/components/97_chapter98cityinn'
 import A8_CHAPTER99WISHFULTHINKING from '@/components/98_chapter99wishfulthinking'
 import A9_CHAPTER100WISHFULPLANTING from '@/components/99_chapter100wishfulplanting'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1damingxinjun",
 			"name" : "0_chapter1damingxinjun",
 			"component" : A_CHAPTER1DAMINGXINJUN
 		},
 		{
 			"path" : "/1_chapter2monarchsystem",
 			"name" : "1_chapter2monarchsystem",
 			"component" : A_CHAPTER2MONARCHSYSTEM
 		},
 		{
 			"path" : "/2_chapter3firstclasspeak",
 			"name" : "2_chapter3firstclasspeak",
 			"component" : A_CHAPTER3FIRSTCLASSPEAK
 		},
 		{
 			"path" : "/3_chapter4assassination",
 			"name" : "3_chapter4assassination",
 			"component" : A_CHAPTER4ASSASSINATION
 		},
 		{
 			"path" : "/4_chapter5preparetoestablishauthority",
 			"name" : "4_chapter5preparetoestablishauthority",
 			"component" : A_CHAPTER5PREPARETOESTABLISHAUTHORITY
 		},
 		{
 			"path" : "/5_chapter6siblingflower",
 			"name" : "5_chapter6siblingflower",
 			"component" : A_CHAPTER6SIBLINGFLOWER
 		},
 		{
 			"path" : "/6_chapter7fallenheartflame",
 			"name" : "6_chapter7fallenheartflame",
 			"component" : A_CHAPTER7FALLENHEARTFLAME
 		},
 		{
 			"path" : "/7_chapter8xuerengui",
 			"name" : "7_chapter8xuerengui",
 			"component" : A_CHAPTER8XUERENGUI
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js